import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

const marker = $( '#marker' );

if($('.mapbox-single')) {

    if ( marker.attr( 'data-lng' ) ) {

        var markerPosition = new mapboxgl.LngLat( marker.attr( 'data-lng' ), marker.attr( 'data-lat' ) );

        mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNrcHplZGE2YTBqbnUycW51aGVkM3RkaWwifQ.-ITM9R92VgZXOeMXKA29WA';

        var map = new mapboxgl.Map({
            container: 'mapboxSingle',
            style: 'mapbox://styles/blackdesk/cklqfnstr5urm17npz7jmz5v0',
            center: markerPosition,
            maxZoom: 18,
            zoom: 15,
        });

        var el = document.createElement( 'div' );
        el.className = 'marker';
        el.style.backgroundImage = 'url(/wp-content/themes/vermeulen/resources/images/marker.svg)';
        el.style.width = '30px';
        el.style.height = '38px';
        el.style.marginTop = '-19px';
        el.backgroundSize = 'cover';

        new mapboxgl.Marker(el)
        .setLngLat( markerPosition )
        .addTo( map );

        map.on( 'load', function() {
            map.resize();
        });
    }

}
